import { render, staticRenderFns } from "./SpecimenFamilyTree.vue?vue&type=template&id=2b04febb"
import script from "./SpecimenFamilyTree.vue?vue&type=script&lang=js"
export * from "./SpecimenFamilyTree.vue?vue&type=script&lang=js"
import style0 from "./SpecimenFamilyTree.vue?vue&type=style&index=0&id=2b04febb&prod&lang=scss"
import style1 from "./SpecimenFamilyTree.vue?vue&type=style&index=1&id=2b04febb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports